import React from 'react'
import { SubscriptionProvider } from './context'
import { Views } from './Views'

const baseClass = "wb-subscription-billing"

const SubscriptionBillingCard = (props) => {
  
  return (
    <SubscriptionProvider {...props}>
      <div id="subscription-details" className={baseClass}>
        <Views />
      </div>
    </SubscriptionProvider>
  )
}

export default SubscriptionBillingCard